import { Alert } from 'antd';
import React from 'react';

export default function AlertBasicServerError({ message = null }) {
  return <Alert type='error' message={message ? message : 'Une erreur interne est survenue, cela peut être dû à votre connexion internet.'} />;
}
